module.exports = __webpack_public_path__ + "static/img/img_introduccion.d76f7f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_introduccion.jpg
// module id = hnbk
// module chunks = 0